import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { getRecoil } from "recoil-nexus";
import styled from "styled-components";
import Pagination from "../../components/Pagination";
import NoticeController, {
  NotificationType,
} from "../../controller/NoticeController";
import { currentStoreState } from "../../recoil/auth";
import "../../styles/CustomModal.css";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";

import "suneditor/dist/css/suneditor.min.css";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const NoticeModal = ({ isVisible, setVisible }: Props) => {
  const onCloseModal = () => {
    setVisible(false);
    setNoticeList([]);
    setPageCount(1);
  };

  // 당일 매출건수의 페이지 개수
  const [pageCount, setPageCount] = useState<number>(1);

  const [noticeList, setNoticeList] = useState<NotificationType[]>([]);
  const [isOpen, setIsOpen] = useState<boolean[]>([]);

  const [isHide, setIsHide] = useState<boolean>(false);

  const getlist = async (page: number) => {
    try {
      if (getRecoil(currentStoreState)) {
        const oParams = {
          store_id: getRecoil(currentStoreState).value?.store_id,
          item_count: 10,
          page,
        };
        const oRes = await NoticeController.getlist(oParams);

        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          console.log("getlist", oResponse);
          if (oResponse.data) {
            setPageCount(Math.ceil(oResponse.data.totalCount / 10));
            setNoticeList([...oResponse.data.list]);
            setIsOpen(new Array(oResponse.data.list.length).fill(false));
          }
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  const getDetail = async (notice_id: number) => {
    try {
      const oParams = {
        notice_id,
      };
      const oRes = await NoticeController.getdetail(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log("getDetail", oResponse);
        if (oResponse.data) {
          const noticeTemp = [...noticeList];
          const noticeIndex = noticeList.findIndex(
            (item) => item.notice_id === notice_id
          );
          if (noticeIndex !== -1) {
            noticeTemp[noticeIndex].content = oResponse.data;
            setNoticeList([...noticeTemp]);
          }
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  const pressPage = async (selected: { selected: number }) => {
    await getlist(selected.selected + 1);
  };

  const checkIsHide = () => {
    let hideTemp = !isHide;
    setIsHide(hideTemp);
    if (hideTemp) {
      AsyncLocalStorage.setItem(
        "hide",
        JSON.stringify(moment(new Date()).format("YYYY/MM/DD"))
      );
    } else {
      AsyncLocalStorage.removeItem("hide");
    }
  };

  const getHideStatus = async () => {
    const hideTemp = await AsyncLocalStorage.getItem("hide");

    if (hideTemp) {
      if (moment(hideTemp).isSame(moment(new Date()).format("YYYY/MM/DD"))) {
        setIsHide(true);
      }
    }
  };

  useEffect(() => {
    if (isVisible) {
      getlist(1);
      getHideStatus();
    }
  }, [isVisible]);

  useEffect(() => {
    const links = document.querySelectorAll("a");
    links.forEach((link) => {
      if (!link.hasAttribute("target")) {
        link.setAttribute("target", "_blank");
      }
      if (!link.hasAttribute("rel")) {
        link.setAttribute("rel", "noopener noreferrer");
      }
    });
  }, [noticeList]);

  interface NotificationProps {
    item: NotificationType;
    index: number;
  }

  const RenderNotificationItem = ({ item, index }: NotificationProps) => {
    const changeIsOpen = async () => {
      await getDetail(item.notice_id);
      const dataTemp = isOpen;
      dataTemp[index] = !dataTemp[index];
      setIsOpen([...dataTemp]);
    };

    return (
      <>
        <div
          className={`listItem ${isOpen[index] && "open"}`}
          onClick={changeIsOpen}
        >
          <div className="row between">
            <div className="row gap">
              <h3>{item.title}</h3>
              {item.wasRead === 0 && <div className="newBadge">NEW</div>}
            </div>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_${
                isOpen[index] ? "up" : "down"
              }_grey.svg`}
              width={24}
              height={24}
              alt="arrow"
            />
          </div>
          <h5>{moment(item.created_at).format("YYYY-MM-DD HH:mm")}</h5>
          {isOpen[index] && (
            <div
              className="contentWrap"
              onClick={(e) => e.stopPropagation()}
              style={{ minHeight: isOpen[index] ? "200px" : "0" }}
            >
              {/* <MDEditor.Markdown className="editor" source={item.content} /> */}
              <div
                className="sun-editor-editable preview"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "noticeModalOverlay",
        modal: "noticeModal",
      }}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
      showCloseIcon={true}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <h1>공지사항</h1>
          <div className="modalContent">
            {noticeList.map((item, index) => (
              <RenderNotificationItem key={index} item={item} index={index} />
            ))}
          </div>
          <Pagination
            pageCount={pageCount}
            forcePage={0}
            handlePageClick={pressPage}
          />
          <label>
            <div className={`checkBox ${isHide && "active"}`}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_bold.svg`}
                width={14}
                height={14}
                alt="체크박스"
              />
            </div>
            오늘 그만 보기
            <input type="checkbox" checked={isHide} onChange={checkIsHide} />
          </label>
        </div>
      </Style>
    </Modal>
  );
};

export default NoticeModal;

const Style = styled.div`
  @font-face {
    font-family: "고운 돋음";
    src: url("${process.env.PUBLIC_URL}/font/Dodum-Regular.ttf")
      format("truetype");
  }
  @font-face {
    font-family: "고운 바탕";
    src: url("${process.env.PUBLIC_URL}/font/Batang-Regular.ttf")
      format("truetype");
  }
  @font-face {
    font-family: "G마켓 산스";
    src: url("${process.env.PUBLIC_URL}/font/GmarketSansTTF.ttf")
      format("truetype");
  }
  @font-face {
    font-family: "청주김생체";
    src: url("${process.env.PUBLIC_URL}/font/ChungjuKimSaeng.ttf")
      format("truetype");
  }
  @font-face {
    font-family: "여기어때 잘난체";
    src: url("${process.env.PUBLIC_URL}/font/Jalnan2TTF.ttf") format("truetype");
  }

  .modal {
    display: flex;
    flex-direction: column;
    height: 75vh;
    align-items: center;
    justify-content: space-between;
    padding: 5% 4% 0 4%;
  }

  h1 {
    font-size: 24px;
    line-height: 30px;
    color: #333333;
    font-weight: 600;
    text-align: center;
  }

  .modalContent {
    flex: 1;
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding-top: 40px;
    border-bottom: 1px solid #f5f5f5;
  }

  .row {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .listItem {
    padding: 14px 0;
    border-bottom: 1px solid #e5e5e5;
    cursor: pointer;
    .row.gap {
      gap: 10px;
    }
    .row.between {
      padding-bottom: 10px;
      h3 {
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        color: #555555;
      }
    }
    h5 {
      color: #979797;
      font-weight: 500;
    }
  }
  .listItem.open {
    padding-bottom: 0;
  }

  .newBadge {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    padding: 4px 12px;
    background: #ff3542;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
    font-weight: 500;
  }

  .contentWrap {
    margin-top: 14px;
    border: 1px solid #e5e5e5;
    border-bottom: none;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    p {
      color: #555555;
      font-weight: 400;
      white-space: normal;
      word-break: break-all;
    }
  }

  label {
    position: absolute;
    bottom: 5%;
    left: 4%;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    color: #555555;

    .checkBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      border: 1px solid #a7a7a7;
      background: #ffffff;
      border-radius: 2px;

      img {
        padding: 0;
      }
    }
    .checkBox.active {
      border: 1px solid #4dd2ae;
      background: #4dd2ae;
    }
    input[type="checkbox"] {
      display: none;
    }
  }

  .sun-editor-editable {
    min-height: 200px;
  }

  .black {
    .sun-editor-editable,
    .preview {
      border: 1px solid #cecece;
      background-color: #000;
      color: #fff;

      hr {
        border-color: #fff;
      }

      thead {
        border-bottom: 2px solid #fff;
      }
      tr,
      td,
      th {
        border: 1px solid #fff !important;
      }
      th {
        background-color: #555;
      }
    }
  }
`;
